export default "<p>user-avator works!</p>\n";